import { render, staticRenderFns } from "./UrunEkstraHizmetItem.vue?vue&type=template&id=32d70c20&scoped=true"
import script from "./UrunEkstraHizmetItem.vue?vue&type=script&lang=js"
export * from "./UrunEkstraHizmetItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d70c20",
  null
  
)

export default component.exports